import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { epinFullFlow } from '@/mocks/epin';

export default function EpinFullFlow() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="全程溯源流程"
          subtitle="从播种投苗到售后召回，八个环节被 ePin 串成一条完整、不可篡改的链路，任一节点都能回溯到责任主体与原始记录。"
        />

        <ol className="mt-12 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {epinFullFlow.map((step, idx) => (
            <li key={step.no}>
              <Reveal delay={Math.min(idx * 60, 360)}>
                <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 transition-colors hover:border-primary-300">
                  <div className="flex items-center justify-between gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 font-heading font-bold text-sm">
                      {step.no}
                    </span>
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                      <i className={`${step.icon} text-lg`}></i>
                    </span>
                  </div>
                  <h3 className="mt-5 font-heading font-bold text-base text-foreground-950">{step.name}</h3>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>

        <Reveal delay={200}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-3 rounded-lg bg-background-100 border border-background-200 px-6 py-5 text-center">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 shrink-0">
              <i className="ri-links-line"></i>
            </span>
            <p className="text-sm text-foreground-700 leading-relaxed">
              每个环节的每一次操作都会作为事件追加到该 ePin 的链路表中，
              <span className="font-medium text-foreground-900">只能新增、不能覆盖</span>
              ，形成完整可审计的可信溯源记录。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}